import { useEffect, useRef } from "react";
import { API_BASE_URL as API } from "../utils/api";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem("_tg_sid");
    if (!sid) {
      // crypto.randomUUID() available in all modern browsers; simple fallback for old ones
      sid =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem("_tg_sid", sid);
    }
    return sid;
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

function beacon(path, body) {
  // Use sendBeacon when available (non-blocking, survives page unload)
  const url = `${API}${path}`;
  const payload = JSON.stringify(body);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
  } else {
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }
}

export function usePageTracking(page) {
  const intervalRef = useRef(null);

  useEffect(() => {
    const sessionId = getSessionId();

    // Record page view
    beacon("/api/analytics/pageview", {
      sessionId,
      page,
      referrer: document.referrer,
    });

    // Send heartbeat immediately + every 30 s to track "active now" — only while the tab is
    // visible (a background tab isn't an active visitor, and each heartbeat is a database write)
    const sendHeartbeat = () => {
      if (!document.hidden) beacon("/api/analytics/heartbeat", { sessionId });
    };
    const onVisible = () => { if (!document.hidden) sendHeartbeat(); };

    sendHeartbeat();
    intervalRef.current = setInterval(sendHeartbeat, 30_000);
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(intervalRef.current);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [page]);
}
